import { createSelector } from 'reselect';
import { initalHomeState } from './../../reducers/Home/reducer';

const carrierData = (state: any) => state.carrier;
const searchData = (state: any) => state.search;

export const makeSelectRecommendedLoaded = () =>
  createSelector([carrierData], carrier => {
    return carrier.recommended.loaded || initalHomeState.recommended.loaded;
  });

export const makeSelectRecommended = () =>
  createSelector(
    [carrierData],
    carrier => carrier.recommended.data || initalHomeState.recommended.data
  );

export const getTopRecommended = () =>
  createSelector(
    [carrierData],
    carrier => carrier.topRecommendationData || initalHomeState.topRecommendationData
  );
export const getRecommendedFilter = () =>
  createSelector([carrierData], carrier => {
    return carrier.recommended.filter || initalHomeState.recommended;
  });

export const makeSelectWatched = () =>
  createSelector([carrierData], carrier => {
    return carrier.watched.data || initalHomeState.watched.data;
  });
export const getSimilarLoads = () =>
  createSelector([carrierData], carrier => {
    return carrier.recommended.data || initalHomeState.recommended.data;
  });
export const makeSelectWatchedLoaded = () =>
  createSelector([carrierData], carrier => {
    return carrier.watched.loaded || initalHomeState.watched.loaded;
  });
export const getTotalWatchedRecords = () =>
  createSelector([carrierData], carrier => {
    return carrier.watched.totalRecords || initalHomeState.watched.totalRecords;
  });
export const getTotalRecommendedRecords = () =>
  createSelector([carrierData], carrier => {
    return (
      carrier.recommended.totalRecords ||
      initalHomeState.recommended.totalRecords
    );
  });
export const getWatchedFilter = () =>
  createSelector([carrierData], carrier => {
    return carrier.watched.filter || initalHomeState.watched;
  });

export const getIdParam = (_state: any, props: any) => {
  return (
    (props && props.match && props.match.params && props.match.params['id']) ||
    ''
  );
};
export const getModule = (_state: any, props: any) => {
  return (
    (props && props.match && props.match.params && props.match.params[0]) || ''
  );
};
export const getLoad = () =>
  createSelector(
    carrierData,
    searchData,
    getIdParam,
    getModule,
    (carrierData, searchData, id, module) => {
      if (module === 'search/results' && searchData) {
        return (
          (searchData.loads &&
            searchData.loads.searchLoads &&
            searchData.loads.searchLoads.find((x: any) => x.loadId === id)) ||
          {}
        );
      }
      if (module === 'home/watched' && carrierData) {
        return (
          (carrierData.watched &&
            carrierData.watched.data &&
            carrierData.watched.data.find((x: any) => x.loadId === id)) ||
          {}
        );
      } 
      if (module === 'home/recommended' && carrierData) {
        let loadDetail = getLoadDetail(carrierData, id);
        if (Object.keys(loadDetail).length == 0 ) {
          loadDetail = getCarrierData(carrierData, id);
        }
        return loadDetail || {};
      }
    }
  );

export const getParams = () =>
  createSelector(searchData, loads => (loads && loads.params) || {});

export const getApiErrorMessage = () =>
  createSelector([carrierData], carrier => {
    return carrier.apiErrorMessage || initalHomeState.apiErrorMessage;
  });

  export const getResultIdMessage = () =>
  createSelector([carrierData], carrier => {
    return carrier.recommended.resultId || initalHomeState.recommended.resultId;
  });

export const getMemberApiError = () =>
  createSelector([carrierData], carrier => {
    return carrier.showMemberAPIError || initalHomeState.showMemberAPIError;
  });

export const getRecommendedMessage = () =>
  createSelector(
    [carrierData],
    carrier => carrier.recommended.message || initalHomeState.recommended.message
  );

export const getRecommendedApiError = () =>
  createSelector([carrierData], carrier => {
    return carrier.recommendedApiError || initalHomeState.recommendedApiError;
  });
  
function getLoadDetail(carrierData: any, id: any) {
  return carrierData.recommended &&
    carrierData.recommended.data &&
    carrierData.recommended.data.find((primaryLoad: any) => {
      return primaryLoad.loadId === id;
    })||{};
}

function getCarrierData(carrierData: any, id: any): any {
  return carrierData && carrierData.recommended && carrierData.recommended.data.reduce((prev: any, primary: any) => prev || primary.similarLoads.find((load: any) => load.loadId === id), undefined);
}

